import React from 'react';

import { Button, Icon, Select } from '../../../../components/ui';

const fullName = (admin) => `${admin.first_name || ''} ${admin.last_name || ''}`;

/**
 * Reviewer picker for the quote status-bar tray: pick an admin, then confirm.
 * The confirm only appears once a reviewer is chosen, and runs the same
 * `updateItem` (PUT /api/quotes/{id}/reviewer) the old arrow did.
 */
const AssignReviewerView = ({
  reviewer,
  setReviewer,
  admins,
  updateItem,
  submitting,
  error,
  initiallyOpen,
}) => (
  <div className="rc-quote-reviewer">
    {error ? <div className="error">Operation failed. Please try again.</div> : null}

    <div className="d-flex align-items-center gap-2">
      <div className="flex-grow-1">
        <Select
          label="Reviewer"
          placeholder="Assign reviewer"
          options={admins.map((admin) => ({ value: admin.id, label: fullName(admin) }))}
          value={reviewer}
          onChange={(value) => setReviewer(value)}
          disabled={submitting}
          defaultOpen={initiallyOpen}
          fullWidth
        />
      </div>

      {reviewer ? (
        <Button
          variant="primary"
          data-btn="quote-reviewer-confirm"
          leadingIcon={<Icon name="Check" size="sm" />}
          loading={submitting}
          onClick={() => updateItem()}
        >
          Assign
        </Button>
      ) : null}
    </div>
  </div>
);

export default AssignReviewerView;
